module.exports = __webpack_public_path__ + "img/mastecard-visa@compress-h37.14975d5a.png";